export default "__VITE_ASSET__CcReY9Va__"